import SuccessIcon from "@/assets/icons/success.svg"
import ErrorIcon from "@/assets/icons/error.svg"
import { WorkflowRunStatusType } from "@/constants/workflowHistory/workflowHistory"
import { LoadingSpinner } from "@/components/custom/LoadingSpinner/LoadingSpinner"
import { Combine } from "lucide-react"

export const WorkflowAppRunStatus = ({
  status,
  appLogoUrl,
  message,
}: {
  status: WorkflowRunStatusType,
  appLogoUrl: string
  message: string
}) => {

  const getRespectiveStatusIcon = () => {
    switch (status) {
      case WorkflowRunStatusType.SUCCESS:
        return <img src={SuccessIcon} className="mr-2" />
      case WorkflowRunStatusType.ERROR:
        return <img src={ErrorIcon} className="mr-2" />
      case WorkflowRunStatusType.PROCESSING:
        return <LoadingSpinner className="h-6 w-6 mr-2" />
      default:
        break
    }
  }

  return (
    <div className="flex flex-row items-center mb-6">
      <div className="flex items-center justify-center rounded-sm border-2 p-1 w-10 h-10 bg-foreground mr-4">
        {appLogoUrl?.length > 0 ? (
          <img
            src={appLogoUrl}
            className="h-inherit max-h-6 max-w-6 w-inherit"
          />
        ) : (
          <Combine className="text-primary h-inherit max-h-6 max-w-6 w-inherit" />
        )}
      </div>
      <div className="flex flex-col items-start justify-center">
        <div className="flex">
          {getRespectiveStatusIcon()}
          <p className="text-primary font-semibold text-lg leading-6 capitalize">{status}</p>
        </div>
        {message?.length && message !== '{}' ? <p className="text-sm text-left text-destructive">{message}</p> : null}
      </div>
    </div>
  )
}
